import { get, post } from '@/utils/apiBase.js';

// 协议-获取协议内容
const getprotocalList = (option) => {
    return get('/apis/admin/bottom/list', option);
  };

// 协议-获取协议内容-通过father_id和son_id
const getprotocalFaterSonDetail = (option) => {
  return get('/apis/admin/bottom/fater_son/detail', option);
};

const getprotocalDetail = (option) => {
    return get('/apis/admin/bottom/detail', option);
  };

// 获取众筹协议列表
const getProjectProtocalList = option => {
  return get('/apis/admin/pro_agreement_list', option)
}
// 公示列表
const getRulePublicityList = option => {
  return get('/apis/admin/bottom/rule_publicity_list', option)
}
// 公示详情
const getRulePublicityDetail = option => {
  return get('/apis/admin/bottom/rule_publicity_detail', option)
}

// 帮助中心-建议与反馈
const postHelpcenterQuestionDetails = option => {
  return post('/helpcenter/question_details', option)
}
export default {
    getprotocalList,
    getprotocalFaterSonDetail,
    getprotocalDetail,
    getProjectProtocalList,
    getRulePublicityList,
    getRulePublicityDetail,
    postHelpcenterQuestionDetails
};
